import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-zinc-950" data-id="element-126">
      <div className="max-w-2xl mx-auto" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-zinc-900 border border-green-500/30 rounded-2xl p-10 text-center relative overflow-hidden" data-id="element-128">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-500 to-green-700" data-id="element-129" />

          <div className="flex justify-center mb-6" data-id="element-130">
            <div className="bg-green-500/10 p-5 rounded-full" data-id="element-131">
              <ShieldCheck className="w-12 h-12 text-green-500" data-id="element-132" />
            </div>
          </div>

          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-133">
            Tu Compra Está Protegida
          </h2>

          <p className="text-gray-400 text-lg leading-relaxed max-w-lg mx-auto" data-id="element-134">
            Si tenés cualquier inconveniente con el acceso o la descarga de tu
            material, lo solucionamos en menos de 24 horas. Tenés 7 días
            completos para verificar que todo funcione perfecto.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm text-zinc-500" data-id="element-135">
            <span data-id="element-136">✓ Soporte por email en 24hs</span>
            <span data-id="element-137">✓ Reenvío inmediato si hay problemas</span>
            <span data-id="element-138">✓ Tu inversión está segura</span>
          </div>
        </motion.div>
      </div>
    </section>;
}